export const DocumentDirectoryPath = "/"
export const CachesDirectoryPath = "/cache"
export const DownloadDirectoryPath = "/download"

export const readFile = async () => ""
export const writeFile = async () => {}
export const unlink = async () => {}
export const exists = async () => false
export const mkdir = async () => {}

export default {
  DocumentDirectoryPath,
  CachesDirectoryPath,
  DownloadDirectoryPath,
  readFile,
  writeFile,
  unlink,
  exists,
  mkdir,
}
